import * as React from 'react';
import { StyleSheet } from 'react-native';
import Colors from '../../../../../constants/Colors';
import { Input, View } from '../../../../../components/Themed';

type Props = {
  questionIndex: number;
  control: any;
  errors: any;
};

export default function TextBoxOptions(props: Props) {
  const { questionIndex, control, errors } = props;

  return (
    <View style={styles.container}>
      <Input
        placeholder="Text"
        label="Textbox Label"
        lightColor={Colors.tinted_grey_100}
        darkColor={Colors.nuetral_grey_700}
        control={control}
        errors={errors}
        name={`questions.${questionIndex}.formLabel`}
        required={true}
        errorMessage="Label is required"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 12,
    gap: 8,
  },
});
